<template>
  <div class="newsletter-container" v-if="!close">
    <div class="body container nested-content">
      <div class="text">
        <h2 class="title">{{ title }}</h2>
        <p class="subtitle">{{ subtitle }}</p>
      </div>
      <div class="email-box-container">
        <span class="af af-close" v-if="canClose" @click="onCloseClick"></span>
        <email-box-form :sending="sending" :done="done" :error="!!emailErrorMsg" @submitEmail="onSubmitEmail" @validationError="onValidationError" />
        <!-- <transition name="fade"> -->
        <span v-if="successMessage || emailErrorMsg" class="message" :class="[emailErrorMsg && 'error']">
          {{ successMessage || emailErrorMsg }}
        </span>
        <!-- </transition> -->
      </div>
    </div>
  </div>
</template>

<script>
import EmailBoxForm from './EmailBoxForm.vue';

export default {
  name: 'Newsletter',
  components: {
    'email-box-form': EmailBoxForm,
  },
  props: {
    title: String,
    subtitle: {
      type: String,
      default: `Keep up with what we’re up to. Unsubscribe at any time.`,
    },
    canClose: {
      type: Boolean,
      default: false,
    },
    subscriptionResult: {
      type: Object,
    },
    sending: {
      type: Boolean,
      default: false,
    },
    done: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      message: '',
      emailErrorMsg: '',
      close: false,
    };
  },
  computed: {
    successMessage() {
      return this.done && this.subscriptionResult.success && this.subscriptionResult.message;
    },
  },
  methods: {
    onValidationError(message) {
      this.emailErrorMsg = message;
      this.$emit('validationError');
    },
    onSubmitEmail(email) {
      this.emailErrorMsg = '';
      this.message = '';
      this.$emit('submitEmail', email);
    },
    onCloseClick() {
      this.close = true;
      this.$emit('close');
    },
  },
};
</script>

<style lang="postcss" scoped>
@import '@/pixel/style/variables';

.newsletter-container {
  position: relative;
  background: var(--grey-ultra-light);
  width: 100%;

  .af-close {
    z-index: 2;
    position: absolute;
    top: 14px;
    right: 14px;
    cursor: pointer;
  }

  .body {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px 24px;

    .text {
      width: 335px;
    }
    .email-box-container {
      margin-left: 24px;
      width: 272px;
    }

    .title {
      text-transform: none;
      white-space: pre-line;
      letter-spacing: 0;
    }
    .subtitle {
      font-size: var(--font-size-12);
      line-height: 1.5em;
      margin-bottom: auto;
    }
  }

  @media (max-width: calc($mobile-breakpoint - 1px)) {
    .body {
      display: block;
      .text,
      .email-box-container {
        width: auto;
      }
      .email-box-container {
        margin-left: 0;
        margin-top: 12px;
      }
    }
  }

  @media (min-width: $tablet-breakpoint) {
    .body {
      .email-box-container {
        width: auto;
      }
    }
  }
}
</style>
